<template>
    <div class="AddNote">
        <template v-if="showAddNote">
            <div
                class="AddNote__add"
                @click.stop="$emit('toggle-note', false)"
            >
                <StreamlineIcon
                    class="AddNote__add-icon"
                    :icon="AddSquare"
                    stroke="white"
                    :fill="textGrey"
                    :size="16"
                />
                Add a Note
            </div>
        </template>
        <template v-else>
            <RPLongFormInput
                ref="input"
                v-model="note"
                label="Add a Note"
                :disabled="isSaving"
                placeholder="New Note"
                class="AddNote__input"
            />
            <RPButton
                class="AddNote__add-button"
                :disabled="$v.$invalid"
                :status="status"
                @click="createNote"
            />
        </template>
    </div>
</template>
<script>
import RPLongFormInput from 'components/Basic/FormElements/RPLongFormInput.vue';
import RPButton from 'components/Basic/Buttons/RPButton.vue';
import stat from 'status/index';
import {AddSquare} from '@reviewpush/streamline-bold/lib/interface-essential/RemoveAdd';
import {textGrey} from 'style/_colors.scss';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {required} from 'vuelidate/lib/validators';

export default {
    name: 'AddNote',

    components: {
        StreamlineIcon,
        RPLongFormInput,
        RPButton
    },
    props: {
        reviewId: {
            type: [String, Number],
            required: true,
        },
        responseId: {
            type: [String, Number],
            required: true,
        },
        showAddNote: {
            type: Boolean,
            default: true
        },
        status: {
            type: String,
            default: stat.SAVING,
        },
    },
    data(){
        return {
            AddSquare,
            textGrey,
            note: ''
        };
    },
    validations: {
        note: {
            required
        }
    },
    computed: {
        isSaving(){
            return this.status === stat.SAVING;
        }
    },
    watch: {
        status(newStat, oldStat){
            if(newStat !== oldStat){
                this.note = '';
            }
        },
        showAddNote(newVal, oldVal){
            if(newVal !== oldVal && !newVal){
                this.$nextTick(() => {
                    this.$refs.input.focus();
                });
            }
        }
    },
    mounted(){
        document.addEventListener('click', this.hideAddNote);
    },
    destroyed(){
        document.removeEventListener('click', this.hideAddNote);
    },
    methods: {
        hideAddNote(e) {
            if(!this.$el.contains(e.target)  & !this.showAddNote){
                this.note = '';
                this.$emit('toggle-note', true);
            }
        },
        createNote(){
            this.$emit('create',{
                responseId: this.responseId,
                note: this.note
            });
        },
    }
};
</script>
<style lang="scss">
    .AddNote {
        padding: 1rem;
        border-top: 1px solid $grey-75;
        display: flow-root;
        &__input{
            margin-bottom: 0.5rem;
        }
        &__add,
        &__add-button {
            float:right;
        }
        &__add{
            cursor: pointer;
            display: flex;
            align-items: center;
            color: $text-grey;
        }
        &__add-icon {
            margin-right: 0.25rem;
        }
    }
</style>
